export default "__VITE_ASSET__BzcolyGU__"